<template>
    <div class="scan-import color-333 fs-14 lh-20">
        <h2 class="fw-600">扫描商品条码，可自动匹配商品信息</h2>
        <img src="../images/scan.svg" alt="">
        <base-input v-model="val"
            ref="elIpt"
            placeholder="手动输入条形码"
            maxlength="14"
            flex="none"
            :isShowError="isShowError"
            :errorMsg="'请输入8-14位商品条码'"
            :show-word-limit="true"
            @recieve-ref="recieveRef"
            @input="iptHandler" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, watch, onBeforeMount, onBeforeUnmount, computed, onMounted } from '@vue/composition-api'
import { inputLimit } from '@/utils'
import debounce from 'lodash/debounce'

export default createComponent({
    props: {
        value: {
            type: String,
            required: true
        }
    },

    setup: (props, ctx) => {
        const elIptLimit = inputLimit(/^\d{0,18}$/)
        const numReg = /\d/
        const isShowError = ref(false)
        let startTime = 0
        let endTime = 0
        let codeSum = ''    // 记录扫码枪输入的值

        const debounceIptErrorHandler = debounce(iptErrorHandler, 1000)

        const val = computed<string>({
            get() {
                return props.value
            },
            set(newVal) {
                ctx.emit('input', newVal)
            }
        })

        onMounted(() => {
            document.addEventListener('keydown', keyDownFn, false)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('keydown', keyDownFn, false)
        })

        function keyDownFn(e) {
            const code = String.fromCharCode(e.keyCode || e.which)
            endTime = Date.now()
            if (endTime - startTime > 50) {
                // 手动输入或者是第一次输入
                if (numReg.test(code)) {
                    codeSum = code.toString()
                } else {
                    codeSum = ''
                }
            } else {
                // 扫码枪输入
                if (numReg.test(code)) {
                    codeSum += code
                }
            }
            startTime = endTime
            if ((e.keyCode || e.which) === 13) {
                // enter
                iptConfirm()
            }
        }

        function iptConfirm() {
            if (codeSum.length > 7) {
                // 扫码枪
                val.value = codeSum
            }
            if (val.value.length > 7) {
                ctx.emit('confirm', val.value)
            }
        }

        function iptHandler() {
            ctx.root.$nextTick(() => {
                elIptLimit(val, 'value')
                debounceIptErrorHandler()
            })
        }

        function iptErrorHandler() {
            const len = val.value.length
            isShowError.value = len > 0 && len < 8
        }

        function recieveRef(iptRef) {
            iptRef.focus()
        }

        return {
            isShowError,
            val,
            elIptLimit,
            iptConfirm,
            iptHandler,
            recieveRef
        }
    }
})
</script>

<style lang="scss" scoped>
.scan-import {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    h2 {
        margin: 130px 0 30px;
    }

    img {
        width: 153px;
        height: 150px;
        margin-bottom: 50px;
    }

    ::v-deep .el-input {
        width: 347px;
    }
}
</style>
